"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortfoliosServiceClient = void 0;
const wealtho2_publicapi_client_1 = require("wealtho2-publicapi-client");
const ServiceClientHelper_1 = require("./ServiceClientHelper");
const enums_1 = require("../enums");
const Constants_1 = __importDefault(require("./Constants"));
class PortfoliosServiceClient {
    constructor(baseUrl, authService, logger = null, apiConfig) {
        const apiClient = new ServiceClientHelper_1.ServiceClientHelper(authService, logger, apiConfig);
        const portfoliosClient = new wealtho2_publicapi_client_1.PortfoliosClient(baseUrl, apiClient.axiosInstance);
        apiClient.setAuthToken(portfoliosClient, authService.getAccessToken());
        this.apiClient = apiClient;
        this.portfoliosClient = portfoliosClient;
    }
    getMultiPortfoliosInfoAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiClient.execute(this.portfoliosClient, this.portfoliosClient.getMultiPortfoliosInfo.bind(this.portfoliosClient), enums_1.PublicApiName.PortfoliosInfos);
        });
    }
    getMultiPortfolioTransactionsAsync(fromDate, toDate, securityCode, clientPortfolios) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiClient.execute(this.portfoliosClient, this.portfoliosClient.getPortfoliosTransactions.bind(this.portfoliosClient), enums_1.PublicApiName.MultiPortfolioTransactions, fromDate, toDate, securityCode, clientPortfolios);
        });
    }
    getMultiPortfolioHoldingsAsync(asOfDate = null, clientPortfolios) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiClient.execute(this.portfoliosClient, this.portfoliosClient.getMultiPortfolioHoldings.bind(this.portfoliosClient), enums_1.PublicApiName.MultiPortfolioHoldings, asOfDate, clientPortfolios);
        });
    }
    getMultiPortfolioPerformanceAsync(compareToBenchmark, fromDate, toDate, clientPortfolios) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiClient.execute(this.portfoliosClient, this.portfoliosClient.getMultiPortfolioPerformance.bind(this.portfoliosClient), enums_1.PublicApiName.MultiPortfolioPerformance, compareToBenchmark, fromDate, toDate, clientPortfolios);
        });
    }
    getMultiPortfolioAssetClassesAsync(asOfDate = null, clientPortfolios) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiClient.execute(this.portfoliosClient, this.portfoliosClient.getMultiPortfolioAssetClasses.bind(this.portfoliosClient), enums_1.PublicApiName.MultiPortfolioAssetClasses, asOfDate, clientPortfolios);
        });
    }
    getPortfolioInfoDetailsAsync(includeValueOverTime, clientPortfolios) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiClient.execute(this.portfoliosClient, this.portfoliosClient.getPortfoliosInfo.bind(this.portfoliosClient), enums_1.PublicApiName.PortfolioInfos, includeValueOverTime, clientPortfolios);
        });
    }
    getPortfoliosAsync(skip, take, scope, scopeKeys) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiClient.execute(this.portfoliosClient, this.portfoliosClient.getPortfolios.bind(this.portfoliosClient), enums_1.PublicApiName.Portfolios, skip, take, scope, scopeKeys);
        });
    }
    // this and other getAll* functions can be made generic remove duplicate logic
    getAllPortfoliosAsync(scope, scopeKeys) {
        return __awaiter(this, void 0, void 0, function* () {
            let skip = this.apiClient.defaultSkip;
            let portfolios = [];
            let totalRecordsSoFar = 0;
            let totalRecords = 0;
            do {
                const take = this.apiClient.defaultTake;
                const portfolioSummaryList = yield this.getPortfoliosAsync(skip, take, scope, scopeKeys);
                if (!portfolioSummaryList.totalRecords) {
                    throw new Error(Constants_1.default.ReturnPayloadWithoutTotalRecords);
                }
                totalRecords = portfolioSummaryList.totalRecords;
                if (!portfolioSummaryList.recordsReturned) {
                    throw new Error(Constants_1.default.ReturnPayloadWithoutRecordsReturned);
                }
                totalRecordsSoFar += portfolioSummaryList.recordsReturned;
                skip += take;
                if (portfolioSummaryList.recordsReturned > 0) {
                    portfolios.push(...portfolioSummaryList.data);
                }
            } while (totalRecordsSoFar < totalRecords);
            return portfolios;
        });
    }
    getPortfolioAsync(key, includePerformance = false, includeAccounts = false, includeRecentDocuments = false, includeTransactions = false) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiClient.execute(this.portfoliosClient, this.portfoliosClient.getPortfolio.bind(this.portfoliosClient), enums_1.PublicApiName.PortfolioByKey, key, includePerformance, includeAccounts, includeRecentDocuments, includeTransactions);
        });
    }
    getPortfolioAssetClassesAsync(key, asOfDate = null) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiClient.execute(this.portfoliosClient, this.portfoliosClient.getPortfolioAssetClasses.bind(this.portfoliosClient), enums_1.PublicApiName.PortfolioAssetClasses, key, asOfDate);
        });
    }
    getPortfolioHoldingsAsync(key, asOfDate = null) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiClient.execute(this.portfoliosClient, this.portfoliosClient.getPortfolioHoldings.bind(this.portfoliosClient), enums_1.PublicApiName.PortfolioHoldings, key, asOfDate);
        });
    }
    getPortfolioPerformanceAsync(skip, take, key, compareToBenchmark = null, timePeriod = null, fromDate = null, toDate = null) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiClient.execute(this.portfoliosClient, this.portfoliosClient.getPortfolioPerformance.bind(this.portfoliosClient), enums_1.PublicApiName.PortfolioPerformance, key, compareToBenchmark, timePeriod, fromDate, toDate, skip, take);
        });
    }
    // this and other getAll* functions can be made generic remove duplicate logic
    getAllPortfolioPerformanceAsync(key, compareToBenchmark = null, timePeriod = null, fromDate = null, toDate = null) {
        return __awaiter(this, void 0, void 0, function* () {
            let skip = this.apiClient.defaultSkip;
            let performanceItems = [];
            let totalRecordsSoFar = 0;
            let totalRecords = 0;
            do {
                const take = this.apiClient.defaultTake;
                const performanceList = yield this.getPortfolioPerformanceAsync(skip, take, key, compareToBenchmark, timePeriod, fromDate, toDate);
                if (!performanceList.totalRecords) {
                    throw new Error(Constants_1.default.ReturnPayloadWithoutTotalRecords);
                }
                totalRecords = performanceList.totalRecords;
                if (!performanceList.recordsReturned) {
                    throw new Error(Constants_1.default.ReturnPayloadWithoutRecordsReturned);
                }
                totalRecordsSoFar += performanceList.recordsReturned;
                skip += take;
                if (performanceList.recordsReturned > 0) {
                    performanceItems.push(...performanceList.data);
                }
            } while (totalRecordsSoFar < totalRecords);
            return performanceItems;
        });
    }
    getPortfolioTransactionsAsync(skip, take, key, securityCode = null, securityName = null, transactionType = null, includeCashTransactions = false, fromDate = null, toDate = null) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiClient.execute(this.portfoliosClient, this.portfoliosClient.getPortfolioTransactions.bind(this.portfoliosClient), enums_1.PublicApiName.PortfolioTransactions, key, securityCode, securityName, transactionType, includeCashTransactions, fromDate, toDate, skip, take);
        });
    }
    // this and other getAll* functions can be made generic remove duplicate logic
    getAllPortfolioTransactionsAsync(key, securityCode = null, securityName = null, transactionType = null, includeCashTransactions = false, fromDate = null, toDate = null) {
        return __awaiter(this, void 0, void 0, function* () {
            let skip = this.apiClient.defaultSkip;
            let transactions = [];
            let totalRecordsSoFar = 0;
            let totalRecords = 0;
            do {
                const take = this.apiClient.defaultTake;
                const transactionList = yield this.getPortfolioTransactionsAsync(skip, take, key, securityCode, securityName, transactionType, includeCashTransactions, fromDate, toDate);
                if (!transactionList.totalRecords) {
                    throw new Error(Constants_1.default.ReturnPayloadWithoutTotalRecords);
                }
                totalRecords = transactionList.totalRecords;
                if (!transactionList.recordsReturned) {
                    throw new Error(Constants_1.default.ReturnPayloadWithoutRecordsReturned);
                }
                totalRecordsSoFar += transactionList.recordsReturned;
                skip += take;
                if (transactionList.recordsReturned > 0) {
                    transactions.push(...transactionList.data);
                }
            } while (totalRecordsSoFar < totalRecords);
            return transactions;
        });
    }
}
exports.PortfoliosServiceClient = PortfoliosServiceClient;
